import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.354 5.263 18.58 6.56a.47.47 0 0 1-.401.228h-8.36a.47.47 0 0 1-.4-.228l-.775-1.3a1.165 1.165 0 0 1 1-1.762h8.707a1.167 1.167 0 0 1 1.003 1.764m3.98 12.237c0 2.333-1.167 7-9.334 7s-9.333-4.667-9.333-7c0-3.874 2.416-6.949 4.322-8.828a.46.46 0 0 1 .328-.132h9.366c.124 0 .24.044.328.132 1.906 1.88 4.322 4.954 4.322 8.828m-6.417.715c0-1.2-.805-2.246-1.963-2.543l-1.476-.372a.85.85 0 0 1-.466-.312.88.88 0 0 1-.179-.537.86.86 0 0 1 .846-.872h.643c.43 0 .791.334.84.777a.875.875 0 0 0 1.74-.193 2.61 2.61 0 0 0-2.027-2.269v-.227a.875.875 0 0 0-1.75 0v.225a2.62 2.62 0 0 0-2.042 2.56c0 .584.195 1.156.542 1.604.35.46.854.793 1.42.939l1.476.372a.87.87 0 0 1 .646.848c0 .233-.09.454-.255.62a.82.82 0 0 1-.591.253h-.643a.856.856 0 0 1-.84-.777.875.875 0 0 0-1.74.192 2.61 2.61 0 0 0 2.027 2.27V21a.875.875 0 0 0 1.75 0v-.225a2.618 2.618 0 0 0 2.042-2.56"
    }, null, -1)
  ])))
}
export default { render: render }